import { authenticatedFetch } from './apiClient.js';

export async function transcribeAudio(audioBlob) {
  const isIOS =
    typeof navigator !== 'undefined' &&
    /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const mimeType = audioBlob.type || 'audio/mp4';

  console.log(
    '[Whisper] blob type:',
    mimeType,
    'size:',
    audioBlob.size,
    'iOS:',
    isIOS
  );

  // iOS Safari falsely advertises webm support but produces malformed
  // containers Whisper rejects with duration: 0. Treat anything from iOS
  // as mp4. Otherwise honor the recorded MIME type.
  let filename;
  let finalBlob;

  if (isIOS || mimeType.includes('mp4')) {
    finalBlob = new Blob([await audioBlob.arrayBuffer()], {
      type: 'audio/mp4',
    });
    filename = 'recording.mp4';
  } else if (mimeType.includes('webm')) {
    finalBlob = new Blob([await audioBlob.arrayBuffer()], {
      type: 'audio/webm',
    });
    filename = 'recording.webm';
  } else if (mimeType.includes('ogg')) {
    finalBlob = new Blob([await audioBlob.arrayBuffer()], {
      type: 'audio/ogg',
    });
    filename = 'recording.ogg';
  } else if (mimeType.includes('mpeg')) {
    finalBlob = audioBlob;
    filename = 'recording.mp3';
  } else {
    finalBlob = audioBlob;
    filename = 'recording.mp4';
  }

  console.log('[Whisper] Sending:', filename, finalBlob.size, 'bytes');

  const formData = new FormData();
  formData.append('file', finalBlob, filename);

  const response = await authenticatedFetch('/api/transcribe', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    let detail = '';
    try {
      const err = await response.json();
      detail = err?.error || '';
    } catch {
      detail = await response.text().catch(() => '');
    }
    throw new Error(`Transcribe error: ${response.status} — ${detail}`);
  }

  const data = await response.json();
  return (data.text || '').trim();
}
